export default "__VITE_ASSET__CSUoiNGI__"